const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const EVENT_KEYS = Object.freeze(['hidden', 'mindmapId', 'nodeId', 'type', 'v']);

export function parseNodeBranchModerationChangedEvent(payload, expectedMindmapId) {
  if (typeof payload !== 'string' || payload.length > 512) return null;
  try {
    const parsed = JSON.parse(payload);
    if (
      !parsed
      || typeof parsed !== 'object'
      || Array.isArray(parsed)
      || parsed.v !== 1
      || parsed.type !== 'node_branch_moderation.changed'
      || !EVENT_KEYS.every((key) => Object.hasOwn(parsed, key))
      || Object.keys(parsed).sort().join(',') !== EVENT_KEYS.join(',')
      || parsed.mindmapId !== expectedMindmapId
      || !UUID_PATTERN.test(parsed.mindmapId)
      || !UUID_PATTERN.test(parsed.nodeId)
      || typeof parsed.hidden !== 'boolean'
    ) return null;
    return Object.freeze({
      v: 1,
      type: 'node_branch_moderation.changed',
      mindmapId: parsed.mindmapId,
      nodeId: parsed.nodeId,
      hidden: parsed.hidden,
    });
  } catch {
    return null;
  }
}

export function deriveNodeBranchModerationProjection({
  relationships,
  branches,
  currentUserId,
  accessRole,
}) {
  const excludedNodeIds = new Set();
  const fadedNodeIds = new Set();
  const warningRootIds = new Set();
  const ownerView = accessRole === 'owner';
  const childrenByParentId = new Map();
  (relationships || []).forEach(({ parentId, childId }) => {
    if (!parentId || !childId) return;
    const children = childrenByParentId.get(parentId) || [];
    children.push(childId);
    childrenByParentId.set(parentId, children);
  });

  const getBranchNodeIds = (rootId) => {
    const branchNodeIds = new Set();
    const pending = [rootId];
    for (let index = 0; index < pending.length; index += 1) {
      const nodeId = pending[index];
      if (!nodeId || branchNodeIds.has(nodeId)) continue;
      branchNodeIds.add(nodeId);
      (childrenByParentId.get(nodeId) || []).forEach((childId) => pending.push(childId));
    }
    return branchNodeIds;
  };

  (branches || []).forEach((branch) => {
    if (!branch?.nodeId) return;
    const branchNodeIds = getBranchNodeIds(branch.nodeId);
    const creatorView = Boolean(
      currentUserId && branch.creatorUserId === currentUserId
    );
    if (ownerView || creatorView) {
      branchNodeIds.forEach((nodeId) => fadedNodeIds.add(nodeId));
      warningRootIds.add(branch.nodeId);
    } else {
      branchNodeIds.forEach((nodeId) => excludedNodeIds.add(nodeId));
    }
  });

  return Object.freeze({
    excludedNodeIds,
    fadedNodeIds,
    warningRootIds,
  });
}

export function filterModeratedGraph(nodes, relationships, excludedNodeIds) {
  const excluded = excludedNodeIds || new Set();
  return Object.freeze({
    nodes: (nodes || []).filter((node) => !excluded.has(node.id)),
    relationships: (relationships || []).filter((relationship) => (
      !excluded.has(relationship.parentId) && !excluded.has(relationship.childId)
    )),
  });
}
